import React from "react";
import {Image, StyleSheet, View} from "react-native";
import {connect} from "react-redux";

class AvatarIcon extends React.Component{
    constructor(props) {
        super(props);
        this.icon  = this.props.icon;
        this.isHeader = this.props.isHeader || false;
    }
    render() {
        var styles = StyleSheet.create({
            placeholder : {
                backgroundColor : '#DFDFDF'
            }
        });
        if(this.icon!=undefined || this.icon!=null){
            return (
                <View style={[(this.isHeader ? {marginLeft:20} : ''),this.props.style]}>
                    <Image style={this.props.style} source={{uri:this.props.icon}} resizeMode={"cover"}></Image>
                </View>
            );
        }else{
            return (
                <View style={[(this.isHeader ? {marginLeft:20} : ''),this.props.style]}>
                    <View style={[styles.placeholder,this.props.style]}></View>
                </View>
            );
        }
    }
}

const mapStateToProps = (state) => {
    /*,icon:state.icon*/
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(AvatarIcon);
